import { atom } from 'jotai'

export const adsReady = atom(false)
